import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { IIoTruckNeedFilling } from '../../models/models'

export type FillType = 'truck' | 'trailer'

interface IFillObj {
	id: number
	type: FillType
}

interface InitialSate {
	fillObj: IFillObj | null
	truckNeedFilling: IIoTruckNeedFilling | null
}

const initialState: InitialSate = {
	fillObj: null,
	truckNeedFilling: null,
}

const trucksSlice = createSlice({
	name: 'trucks',
	initialState,
	reducers: {
		setFillObj(state, action: PayloadAction<IFillObj | null>) {
			state.fillObj = action.payload
		},
		setTruckNeedFilling(state, action: PayloadAction<IIoTruckNeedFilling | null>) {
			state.truckNeedFilling = action.payload
		},
	},
})

export const trucksActions = trucksSlice.actions
export const trucksReducer = trucksSlice.reducer
